import styled from 'styled-components';
import { InteriorSelectStyled } from '../InteriorSelectStyled';
import { rem } from 'polished';

export const InteriorSelectStyledDS = styled(InteriorSelectStyled)`
    .interior {
        border: solid 1px ${({ theme }) => theme.colors.grey16};
        border-radius: ${rem(8)};

        &.isSelected,
        &:hover {
            border: 1px solid ${({ theme }) => theme.colors.secondary};
            background: ${({ theme }) => theme.colors.grey4};
            .inner {
                border-radius: ${rem(5)};
                border-color: ${({ theme }) => theme.colors.secondary};
            }
        }
    }
    .interiorTitle {
        color: ${({ theme }) => theme.colors.black};
        .icon {
            border-color: ${({ theme }) => theme.colors.black1};

            .selected {
                width: ${rem(14)};
                height: ${rem(14)};
                top: ${rem(4)};
                left: ${rem(4)};
            }
        }
    }
    .interiorTitle,
    .interiorDescriptionLink {
        font-size: ${({ theme }) => theme.fontSizes.h5};

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`;
